import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	EditorFeatureConfigSymbol,
	IPropsStore,
	Props,
} from '@wix/thunderbolt-symbols'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { getFullId } from '@wix/thunderbolt-commons/'
import {
	forceStateInternal,
	revertForceStateInternal,
	revertQuickChangeInternal,
	setQuickChangeInternal,
} from './stylableApiFunctions'
import { name } from './symbols'
import { StylableApiState, ViewerManagerStylableApiEditorConfig } from './types'
import { mergeStylesheets } from '@wix/stylable-panel-drivers'

const viewerManagerStylableApiFactory = (
	{ stylableInstance, compIdToStyleIds }: ViewerManagerStylableApiEditorConfig,
	browserWindow: NonNullable<BrowserWindow>,
	props: IPropsStore
): IViewerManagerImplementor<'stylable'> => {
	const state: StylableApiState = {
		quickChanges: {},
		forceState: {},
	}
	return {
		stylable: {
			getStylableEditorInstance: () => stylableInstance,
			// Expose mergeStylesheets for bundle size optimization (no need to re-import it from somewhere else)
			mergeStylesheets,
			setQuickChanges: (compId, selector, declarationMap) => {
				const templateCompId = getFullId(compId)

				return compIdToStyleIds[templateCompId]?.forEach((styleId) => {
					setQuickChangeInternal(
						stylableInstance,
						styleId,
						compId,
						selector,
						declarationMap,
						browserWindow,
						state
					)
				})
			},
			revertQuickChanges: (compId) => {
				const templateCompId = getFullId(compId)
				return compIdToStyleIds[templateCompId]?.forEach((styleId) =>
					revertQuickChangeInternal(stylableInstance, styleId, compId, browserWindow, state)
				)
			},
			forceState: (compId, forceStateParams) => {
				const templateCompId = getFullId(compId)
				return compIdToStyleIds[templateCompId].forEach((styleId) =>
					forceStateInternal(state, props, stylableInstance, styleId, compId, forceStateParams)
				)
			},
			revertForceState: (compId) => {
				const templateCompId = getFullId(compId)
				return compIdToStyleIds[templateCompId]?.forEach((styleId) =>
					revertForceStateInternal(state, props, compId, styleId)
				)
			},
		},
	}
}
export const ViewerManagerStylableApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), BrowserWindowSymbol, Props],
	viewerManagerStylableApiFactory
)
